export class DocumentHelper {

    /** Indica si la longitud en bytes es válida */
    static isValidSize(size: number) {
        return size < 20971468; // 20 MB
    }

    /** Tamaño máximo de documentos en lenguaje natural. */
    static maxSizeFriendlyName() {
        return "20 MB";
    }
}